<app-header [showNavigation]="true"></app-header>
<main class="content">
  <div class="main-container">
      <app-splash/>
      <app-question-cta/>
      <app-instructions/>
      <app-products/>
      <app-faq/>
      <app-statistics/>
      <app-institutions/>
  </div>
</main>
<app-footer [showCertificates]="true"></app-footer>
